module.exports = __webpack_public_path__ + "img/preview.940b2432.webp";